import Vue from 'vue';
import http from './http_services';

const nominations = {
	state: {
		nomination_suggestions: [],
    show_single_nom_share: false
	},

  get_current_nomination_suggestions_by_contest: function(instance_contestid) {
    let vm = this;
    let suggestions = [];

    // LOOP THROUGH SUGGESTIONS
    for(var key in vm.state.nomination_suggestions) {
      if(vm.state.nomination_suggestions[key].instance_contestid == instance_contestid) {
        suggestions.push(vm.state.nomination_suggestions[key]);
      }
    }

    return suggestions;
  },

  get_nomination_suggestions_by_contest: function(instance_contestid) {
    let vm = this;

    // FETCH NOMINATIONS
    vm.fetch_nominations_suggestions_by_contest(instance_contestid)
      .then(function(response) {
        Vue.set(vm.state, 'nomination_suggestions', response.data.data);
      })
  },

  get_current_nom_share_status: function() {
    return this.state.show_single_nom_share;
  },

  change_single_nom_share_status: function(status) {
    this.state.show_single_nom_share = status;
  },

  fetch_nominations_suggestions_by_contest: function(instance_contestid) {
    let vm = this;
    let requested_set = 'nomination_suggestions'

    return http.get_api_data(requested_set, {instance_contestid: instance_contestid});
  },

  record_nomination: function(data) {
    // ADD REQUESTED ACTION
    data.requested_action = 'add_new_nomination';

    return http.save_new_nomination(data);
  },

	record_single_nomination: function(contest, nomination_text) {
    if(nomination_text != '' && contest.label != 'undefined') {

      let nomination = [{
        contest: contest.label,
        nominee: nomination_text
      }];

      this.record_nominations(nomination);

      return {
      	status: true,
      	message: 'Nomination saved successfully'
      }
    }
    else {
    	return {
      	status: false,
      	message: 'Error: missing required nomination fields.'
      }
    }
  },

	record_nominations(noms) {
		let my_noms = this.state.my_nominations;
		my_noms = [...my_noms, ...noms];
		// my_noms = Set(my_noms);
		Vue.set(this.state, 'my_nominations', my_noms);
	}
}

export default nominations


// WEBPACK FOOTER //
// ./src/store/modules/mod_nominations.js